// PLEASE MAKE SURE THIS KEYS MATCH the keys in core.scss file

export enum ThemeEnum {

  TitleFontFamily = "--title-font-family",
  TitleFontWeight = "--title-font-weight",
  BodyFontFamily = "--body-font-family",

  Primary = '--primary',
  Accent = '--accent',

  // Error= '--error',
  // Warning= yellow,
  // Info= blue,
  // Success= lightgreen,
  Footer = '--footer',

  Icon = '--icon',

  Secondary = '--secondary',

  Error = '--error',
  Success = '--success',

  PrimaryForeground = '--primary-foreground',
  SecondaryForeground = '--secondary-foreground',
  AccentForeground = '--accent-foreground',

  FooterForeground = '--footer-foreground',

  LinkForeground = '--link-foreground',

  TextAlignBody = '--text-align-body',
  TextAlignTitle = '--text-align-title',
  TextAlignInputs = '--text-align-inputs',

  /* /Material Design colors*/

  /* MISC */

  CollapseHeaderBackground = '--collapse-header-background',
  CollapseHeaderForeground = '--collapse-header-foreground',
  CollapseHeaderBorder = '--collapse-header-border',
  CollapseBorderRadius = '--collapse-border-radius',

  CollapseHeaderOpenBackground = '--collapse-header-open-background',
  CollapseHeaderOpenForeground = '--collapse-header-open-foreground',
  CollapseHeaderOpenBorder = '--collapse-header-open-border',

  CollapseContentForeground = '--collapse-content-foreground',
  CollapseContentBackground = '--collapse-content-background',
  CollapseContentBorder = '--collapse-content-border',
  CollapseContentBulletColor = '--collapse-content-bullet-color',

  BulletStyle = '--bullet-style',

  FrequencyOfAccessForegroundColor = '--frequency-of-access-foreground-color',

  /* /MISC */

  /* ICON  */

  IconColor = '--icon-color',
  IconHoverColor = '--icon--hover-color',
  IconWelcomeColor = '--icon-welcome-color',
  IconLoadingIcon = '--icon-loading-color',
  IconErrorColor = '--icon-error-color',
  IconQuestionColor = '--icon-question-color',
  IconSuccessColor = '--icon-success-color',
  IconSuccessTickColor = '--icon-success-tick-color',
  IconSearchColor = '--icon-search-color',

  /* /ICON  */

  /* APP  */

  Background = '--background',
  Foreground = '--foreground',

  HeaderBackground = '--header-bg',
  FooterBackgroundColor = '--footer-bg-color',

  HeaderForegroundColor = '--header-foreground-color',
  FooterForegroundColor = '--footer-foreground-color',
  BurgermenuBackground = '--burgermenu-background',

  BurgermenuForegroundColor = '--burgermenu-background-color',

  BodyForegroundColor = '--body-foreground-color',

  BodyTopBottomBorder = '--body-top-bottom-border',

  BodyTopBorder = '--body-top-border',
  BodyBottomBorder = '--body-bottom-border',

  ModalHeaderBackground = '--modal-header-background',
  ModalHeaderForegroundColor = '--modal-header-foreground-color',

  BurgermenuLinkForegroundColor = '--burgermenu-link-foreground-color',

  TitleForegroundColor = '--title-foreground-color',

  /* APP  */

  /* BUTTON  */
  ButtonBackground = '--button-background',
  ButtonForegroundColor = '--button-foreground-color',
  ButtonBorder = '--button-border',

  ButtonHoverBackground = '--button-hover-background',
  ButtonHoverForegroundColor = '--button-hover-foreground-color',
  ButtonHoverBorder = '--button-hover-border',

  ButtonActiveBackground = '--button-active-background',
  ButtonActiveForegroundColor = '--button-active-foreground-colorm',
  ButtonActiveBorder = '--button-active-border',

  ButtonDisabledBackground = '--button-disabled-background',
  ButtonDisabledForegroundColor = '--button-disabled-foreground-colorm',
  ButtonDisabledBorder = '--button-disabled-border',

  ButtonFocusBorder = '--button-focus-border',

  ButtonAccentBackground = '--button-accent-background',
  ButtonAccentBorder = '--button-accent-border',
  ButtonAccentForeground = '--button-accent-foreground',

  ButtonAccentHoverBackground = '--button-accent-hover-background',
  ButtonAccentHoverForegroundColor = '--button-accent-hover-foreground-color',
  ButtonAccentHoverBorder = '--button-accent-hover-border',

  ButtonAccentActiveBackground = '--button-accent-active-background',
  ButtonAccentActiveForegroundColor = '--button-accent-active-foreground-color',
  ButtonAccentActiveBorder = '--button-accent-active-border',

  ButtonAccentDisabledBackground = '--button-accent-disabled-background',
  ButtonAccentDisabledForegroundColor = '--button-accent-disabled-foreground-color',
  ButtonAccentDisabledBorder = '--button-accent-disabled-border',

  ButtonAccentFocusBorder = '--button-accent-focus-border',

  ButtonBorderRadius = '--button-border-radius',
  ButtonTextTransform = '--button-text-transform',

  /* /BUTTON  */

  /* INPUT  */

  InputBackground = '--input-background',
  InputBorder = '--input-border',
  InputForegroundColor = '--input-foreground-color',
  InputLabelColor = '--input-label-color',

  InputDisabledBackground = '--input-disabled-background',
  InputDisabledBorder = '--input-disabled-border',
  InputDisabledForegroundColor = '--input-disabled-foreground-color',

  InputFocusBackground = '--input-focus-background',
  InputFocusBorder = '--input-focus-border',
  InputFocusForegroundColor = '--input-focus-foreground-color',
  InputFocusLabelColor = '--input-focus-label-color',

  InputInvalidBackground = '--input-invalid-background',
  InputInvalidBorder = '--input-invalid-border',
  InputInvalidForegroundColor = '--input-invalid-foreground-color',
  InputInvalidBoxShadow = '--input-invalid-box-shadow',
  InputInvalidLabelColor = '--input-invalid-label-color',

  InputValidBackground = '--input-valid-background',
  InputValidBorder = '--input-valid-border',
  InputValidForegroundColor = '--input-valid-foreground-color',
  InputValidBoxShadow = '--input-valid-box-shadow',
  InputValidLabelColor = '--input-valid-label-color',

  InputPlaceholderForegroundColor = '--input-placeholder-foreground-color',

  InputSelectionForegroundColor = '--input-selection-foreground-color',
  InputSelectionBackground = '--input-selection-foreground',

  /* /INPUT  */

  /* CHECKBOX */

  CheckboxBackground = '--checkbox-background',
  CheckboxBorder = '--checkbox-border',

  CheckboxCheckedBackground = '--checkbox-checked-background',
  CheckboxCheckedBorder = '--checkbox-checked-border',
  CheckboxCheckedForegroundColor = '--checkbox-checked-foreground',

  CheckboxInvalidBackground = '--checkbox-invalid-background',
  CheckboxInvalidBorder = '--checkbox-invalid-border',
  CheckboxInvalidBoxShadow = '--checkbox-invalid-box-shadow',

  /* /CHECKBOX */

  /* SPINNER */

  SpinnerLoadingColor = '--spinner-loading-background',

  /* /SPINNER */

  /* PROGRESS-BAR */

  ProgressBackground = '--progress-background',
  ProgressBorder = '--progress-bar-border',
  ProgressHeight = '--progress-height',

  ProgressPadding = '--progress-bar-padding',
  ProgressBorderRadius = '--progress-bar-border-radius',

  ProgressBarBackground = '--progress-bar-background',
  ProgressBarForeground = '--progress-bar-foreground',

  /* /PROGRESS-BAR */

  BankItemForeground = '--bank-item-foreground',
  BankItemBackground = '--bank-item-background',
  BankItemBorder = '--bank-item-border',
  BankItemArrow = '--bank-item-arrow',

  BrandHeaderFontSize = '--brand-font-size',
  BrandHeaderForegroundColor = '--brand-foreground-color',
  BrandHeaderFontFamily = '--brand-font-family',
  BrandHeaderFontWeight = '--brand-font-weight',

  /* SUCCESS PAGE */
  SuccessTitleFontSize = '--success-title-font-size',
  SuccessTextFontSize = '--success-text-font-size'
}

type ThemeKeys = keyof ThemeEnum;
type ThemeValueKeys = keyof typeof ThemeEnum;

export type Theme = { [k in ThemeValueKeys]: string };
export type ThemedCss = { [k in ThemeValueKeys]: string };
